import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { getModuleViewComponents, constantRoutes, defaultRoutes } from './constantRoutes.js'
import { isProd } from '@/support/helper.js'
import guard from './guard/index.js'
import { ROUTER_MODE } from './mode.js'
import staticRouter from './modules/staticRouter.js'
import dynamicRouter from './modules/dynamicRouter.js'

// const userStore = useUserStore()
getModuleViewComponents()

// 路由模式：static（读取子模块 routes.ts）| dynamic（后台权限路由）
const routes: RouteRecordRaw[] = ROUTER_MODE === 'static' ? staticRouter : dynamicRouter

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // 路由滚动
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, behavior: 'smooth' }
  }
})

// 挂载路由守卫（传入当前路由模式）
guard(router, ROUTER_MODE)

export { constantRoutes, defaultRoutes }
export default router
